// Deep links into the Teams app and into a Teams call. No teams-js here, so
// the Teams shell, the browser pages and the tests can all use it.

/** manifest/manifest.json "id". */
export const TEAMS_APP_ID = '7af628ef-f0d7-4095-9b89-eeabf8ee64d8';
export type TeamsTab = 'quickdial-user' | 'quickdial-phonemenu';

export function teamsTabLink(tab: TeamsTab): string {
  return `https://teams.microsoft.com/l/entity/${TEAMS_APP_ID}/${tab}`;
}

export interface CallTarget { type?: string; email?: string; phoneNumber?: string }

/** The `users=` value of a teams.microsoft.com call link: a tenant user by
 *  UPN, anything with a number by `4:<digits>`, else the UPN if there is one. */
export function teamsCallTarget(t: CallTarget): string | null {
  const num = t.phoneNumber?.replace(/[\s()-]/g, '');
  if (t.type === 'user' && t.email) return encodeURIComponent(t.email);
  if (num) return `4:${encodeURIComponent(num)}`;
  return t.email ? encodeURIComponent(t.email) : null;
}

export function teamsCallLink(t: CallTarget): string | null {
  const who = teamsCallTarget(t);
  return who ? `https://teams.microsoft.com/l/call/0/0?users=${who}` : null;
}
